import type { FC, ReactNode } from 'react';

type Props = {
  title: ReactNode;
  /** 右侧主操作（如「新建」） */
  extra?: ReactNode;
  children?: ReactNode;
};

/** 列表页头：标题 + 右侧操作（UI-STANDARDS §3.1） */
export const IpcPageHeader: FC<Props> = ({ title, extra, children }) => (
  <header className="ipc-page-header ipc-page-header--with-extra">
    <div className="ipc-page-header__main">
      <h1 className="ipc-page-title">{title}</h1>
      {extra != null && <div className="ipc-page-header__extra">{extra}</div>}
    </div>
    {children}
  </header>
);
